/**
 * Season 2 (2012) rune definitions — marks / seals / glyphs / quintessences.
 * Values from docs/game_specs/spells_runes_masteries.md (primary flats).
 */

export const RUNE_SLOT_LIMITS = Object.freeze({
  mark: 9,
  seal: 9,
  glyph: 9,
  quintessence: 3
});

export const RUNE_CATALOG = Object.freeze({
  mark_flat_ad: {
    id: 'mark_flat_ad',
    type: 'mark',
    name: 'Greater Mark of Attack Damage',
    stats: Object.freeze({ ad: 0.95 })
  },
  mark_armor_pen: {
    id: 'mark_armor_pen',
    type: 'mark',
    name: 'Greater Mark of Armor Penetration',
    stats: Object.freeze({ armorPen: 1.33 })
  },
  seal_flat_armor: {
    id: 'seal_flat_armor',
    type: 'seal',
    name: 'Greater Seal of Armor',
    stats: Object.freeze({ armor: 1.41 })
  },
  seal_hp_per_level: {
    id: 'seal_hp_per_level',
    type: 'seal',
    name: 'Greater Seal of Scaling Health',
    stats: Object.freeze({ hpPerLevel: 1.33 })
  },
  glyph_flat_mr: {
    id: 'glyph_flat_mr',
    type: 'glyph',
    name: 'Greater Glyph of Magic Resist',
    stats: Object.freeze({ mr: 1.34 })
  },
  glyph_flat_ap: {
    id: 'glyph_flat_ap',
    type: 'glyph',
    name: 'Greater Glyph of Ability Power',
    stats: Object.freeze({ ap: 1.19 })
  },
  quint_gold_per_10: {
    id: 'quint_gold_per_10',
    type: 'quintessence',
    name: 'Greater Quintessence of Gold',
    stats: Object.freeze({ goldPer10: 1 })
  },
  quint_flat_ad: {
    id: 'quint_flat_ad',
    type: 'quintessence',
    name: 'Greater Quintessence of Attack Damage',
    stats: Object.freeze({ ad: 2.25 })
  },
  quint_ms_percent: {
    id: 'quint_ms_percent',
    type: 'quintessence',
    name: 'Greater Quintessence of Movement Speed',
    stats: Object.freeze({ msPercent: 0.015 })
  }
});

function fill(id, n) {
  return Array(n).fill(id);
}

export const RUNE_PAGE_PRESETS = Object.freeze({
  standard_ad: Object.freeze({
    id: 'standard_ad',
    name: 'Standard AD',
    marks: Object.freeze(fill('mark_flat_ad', 9)),
    seals: Object.freeze(fill('seal_flat_armor', 9)),
    glyphs: Object.freeze(fill('glyph_flat_mr', 9)),
    quintessences: Object.freeze(fill('quint_flat_ad', 3))
  }),
  armor_pen: Object.freeze({
    id: 'armor_pen',
    name: 'Armor Pen AD',
    marks: Object.freeze(fill('mark_armor_pen', 9)),
    seals: Object.freeze(fill('seal_flat_armor', 9)),
    glyphs: Object.freeze(fill('glyph_flat_mr', 9)),
    quintessences: Object.freeze(fill('quint_flat_ad', 3))
  }),
  gp10: Object.freeze({
    id: 'gp10',
    name: 'Gold / 10',
    marks: Object.freeze(fill('mark_flat_ad', 9)),
    seals: Object.freeze(fill('seal_flat_armor', 9)),
    glyphs: Object.freeze(fill('glyph_flat_mr', 9)),
    quintessences: Object.freeze(fill('quint_gold_per_10', 3))
  })
});

export function listRunePagePresetIds() {
  return Object.keys(RUNE_PAGE_PRESETS);
}
